module.exports = __webpack_public_path__ + "static/media/Waterscape1.6873d208.jpg";